module.exports = __webpack_public_path__ + "static/media/career-hero.67a16250.jpg";